export function locationProviderConfig($locationProvider) {
	"ngInject";
	$locationProvider.html5Mode(true);
}


// WEBPACK FOOTER //
// ./sources/config/locationProvider.config.js